import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

    private storageKey = 'centrex_lang';
    private defaultLanguage = 'en';
    private allowedLanguages = ['es', 'en']

    constructor(
        private trans: TranslateService
    ) {}

    getLanguage() {
        if (this.allowedLanguages.includes(navigator.language )) {
            return navigator.language;
        }
        return this.defaultLanguage;
    }

    setLanguage(lang: string) {
        if (!this.allowedLanguages.includes(lang)) {
            console.log('lang ' + lang + ' is not in the allowed lang list');
            return;
        }
        localStorage.setItem(this.storageKey, lang);
        this.trans.use(lang);
    }

    autoResolveLanguage() {
        this.setLanguage(this.getLanguage());
    }
}
